import { getText } from 'api/apiRequest';

export const reportGenerator = {
  getReportGeneratorUrl: () => getText('v1/ReportGenerator/GetReportGeneratorUrl'),
  getReportGeneratorAppAuthToken: () =>
    getText('v1/ReportGenerator/GetReportGeneratorAppAuthToken'),
};
